import sdl from '@jds/react-generated-sdl/JDSCheckbox';
import type { JDSCheckboxProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputCheckboxProps } from '../logic';

const Component = (props: InputCheckboxProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    checked = false,
    indeterminate = false,
    size = 'medium',
    disabled = false,
    state = 'undefined',
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { checked, indeterminate, size, disabled, state, ariaLabel, ...rest },
    'JDSCheckbox',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputCheckbox = withLogic(Component) as React.FC<InputCheckboxProps> & {
  slotName?: string;
};

InputCheckbox.displayName = 'InputCheckbox';
InputCheckbox.slotName = 'jds_checkbox';

export { InputCheckbox, type JDSCheckboxProps };
